import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import BookingsList from '../components/Booking/BookingsList'; // ÚJ IMPORT

const BookingsPage = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" gutterBottom>
          Foglalásaim és Ajánlatkéréseim
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Itt kezelheted az összes beérkezett és elküldött ajánlatkérésed, valamint a megerősített foglalásaid.
        </Typography>
      </Box>
      <BookingsList /> {/* Az új komponens beágyazása */}
    </Container>
  );
};

export default BookingsPage;